import React from "react";
import { Container, Row, Tab as BootstrapTab } from "react-bootstrap";
import classNames from "classnames";
import PropTypes from "prop-types";

import "./styles.scss";

const Tabs = ({ children, className = "" }) => (
  <BootstrapTab.Container defaultActiveKey={0}>
    <Container fluid className={classNames("mydpd-tabs", className)}>
      <Row>{children}</Row>
    </Container>
  </BootstrapTab.Container>
);

Tabs.propTypes = {
  children: PropTypes.any,
  className: PropTypes.string,
};

export default Tabs;
